<script>
import ListInstructorLiveClassComponent from '../../features/lists/ListInstructorLiveClassComponent';
import ModalLiveClassView from '../modals/ModalLiveClassView';
import ModalImportView from '../../../shared/views/ModalImportView';

export default {
  name: 'ListInstructorLiveClassView',
  components: {
    'modal-live-class-view': ModalLiveClassView,
    'modal-import': ModalImportView,
  },
  extends: ListInstructorLiveClassComponent,
};
</script>

<template>
  <div class="list-body">
    <el-row
      :gutter="20"
      class="section-ctrl liveClasses"
    >
      <el-col
        :xs="24"
        :sm="14"
        :md="14"
        :lg="14"
        :xl="14"
        class="header-right"
      >
        <el-button-group class="btn-grp-drp">
          <el-button
            type="primary"
            size="small"
            class="btn-primary"
            icon="el-icon-circle-plus"
            :disabled="!onCanCreate(modulePermissions)"
            @click="onCreate"
          >
            Crear Clase en Vivo
          </el-button>
          <!-- <el-dropdown>
            <el-button size="small" class="btn-primary-light">
              <i class="fa fa-ellipsis-v"></i> M&aacute;s Opciones
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  size="small"
                  class="btn-primary-light"
                  icon="el-icon-upload"
                  @click="onShowImport"
                  :disabled="!onCanCreate(modulePermissions)"
                  >Importar Clases en Vivo</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  size="small"
                  class="btn-primary-light btn-primary-full"
                  @click="onExportToExcel()"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i class="fa fa-file-excel-o" aria-hidden="true"></i> Exportar
                  Excel
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button size="small" class="btn-white">
                  <i class="fa fa-file-pdf-o" aria-hidden="true"></i> Exportar PDF
                </el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            popper-class="filter-dropdown-popper"
          >
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i
                class="fa fa-filter"
                aria-hidden="true"
              /> <span class="hidden-xs-only">Filtrar Por</span> <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.courseFilter"
                    size="small"
                    filterable
                    remote
                    clearable
                    placeholder="Curso..."
                    :remote-method="onSearchCourse"
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.courseFilter.id, 'CourseId')"
                    @focus="onFocusCourse"
                  >
                    <el-option
                      v-for="item in courses"
                      :key="item.id"
                      :label="item.title"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.isFinishedFilter"
                    size="small"
                    clearable
                    placeholder="Fianlizado..."
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.isFinishedFilter, 'IsFinished')"
                  >
                    <el-option
                      v-for="item in finishedStatuses"
                      :key="item.id"
                      :label="item.name"
                      :value="item.state"
                    />
                  </el-select>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown> 
        </el-button-group>
      </el-col>
      <el-col
        :xs="24"
        :sm="10"
        :md="10"
        :lg="10"
        :xl="10"
        class="header-left search-inputs-row"
      >
        <el-input
          v-model="filterOptions.titleFilter"
          size="small"
          placeholder="Buscar titulo..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(filterOptions.titleFilter, 'Title')"
        />
      </el-col>
    </el-row>
    <el-table
      v-loading="isListLoading"
      :data="collection"
      empty-text="No se encontraron resultados."
      element-loading-spinner="el-icon-loading"
      :element-loading-text="listLoadingMessage"
    >
      <el-table-column
        label="TITULO"
        min-width="300"
      >
        <template #default="scope">
          <div>
            {{ scope.row.title }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="CURSO"
        min-width="250"
      >
        <template #default="scope">
          <el-tag
            v-if="scope.row.course"
            type="info"
            effect="plain"
          >
            {{ scope.row.course }}
          </el-tag>
          <el-tag
            v-if="!scope.row.course"
            type="info"
            effect="plain"
          >
            Sin Curso Asignado
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="Url Stream"
        min-width="250"
      >
        <template #default="scope">
          {{ scope.row.streamUrl }}
        </template>
      </el-table-column>
      <el-table-column
        label="FINALIZADO"
        width="140"
        align="center"
      >
        <template #default="scope">
          <el-switch
            v-model="scope.row.isFinished"
            active-color="#13ce66"
            active-text="SI"
            inactive-text="NO"
            size="small"
            @change="onUpdateFinished(scope.row.id, scope.row.isFinished)"
          />
        </template>
      </el-table-column>
      <!--
      <el-table-column label="CURSO" min-width="250">
        <template slot-scope="scope">
          <div>
            {{ scope.row.curse }}
          </div>
        </template>
      </el-table-column>
      -->

      <!--
      <el-table-column prop="createdAt" label="CREACIÓN" :width="140" align="center">
        <template slot-scope="scope">
          <el-tag  type="info" effect="plain"><i class="el-icon-date"></i> {{scope.row.createdAt | formatDate}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="ACTUALIZACIÓN" :width="140" align="center">
        <template slot-scope="scope">
          <el-tag v-if="onCheckUpdatedAt(scope.row.updatedAt)" type="info" effect="plain"><i class="el-icon-date"></i> {{scope.row.updatedAt | formatDate}}</el-tag>
        </template>
      </el-table-column>-->
      <el-table-column
        label="OPCIONES"
        :width="160"
        align="center"
        text-align="center"
      >
        <template #default="scope">
          <el-dropdown @command="onChangeItemOptions">
            <el-button size="small">
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
              />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="{ command: 'watch', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-video-play"
                    aria-hidden="true"
                  /> Ver en Vivo
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'edit', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-edit"
                    aria-hidden="true"
                  /> Mostrar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'delete', item: scope.row }"
                  :disabled="!onCanDelete(modulePermissions)"
                >
                  <i
                    class="el-icon-delete"
                    aria-hidden="true"
                  /> Eliminar
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-model:current-page="currentPage"
      size="small"
      layout="prev, pager, next"
      :page-count="pagination.totalPages"
      @current-change="onPageChange"
    />
    <modal-live-class-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>

